import {useDispatch, useSelector} from "react-redux";
import {getTransactionFilter, toggleTransactionFilter} from "../../../ducks/transactions-duck.js";
import CloseIcon from "mdi-react/CloseIcon.js";
import FilterToggleButton, {FILTER_TOGGLE_BUTTON_STATE} from "../../util/filter-toggle-buttons/FilterToggleButton";

export default ({
                    icon,
                    prop = 'filterBurn',
                }) => {

    const dispatch = useDispatch()
    const value = useSelector(state => getTransactionFilter(state, prop))

    let state = FILTER_TOGGLE_BUTTON_STATE.PASSIVE
    if(value === -1){
        state = FILTER_TOGGLE_BUTTON_STATE.DEACTIVATED
    }
    if(value === 1){
        state = FILTER_TOGGLE_BUTTON_STATE.ACTIVE
    }

    return (
        <FilterToggleButton
            icon={icon}
            onClick={() => dispatch(toggleTransactionFilter(prop))}
            className={`filter-toggle-button`}
            state={state}
        >
            {value === -1 && <CloseIcon className='close-icon'/>}
        </FilterToggleButton>
    )
}